import { Fragment, h, render } from "preact";
import { useEffect, useState } from "preact/hooks";

const FADE_DURATION = 250;

export default function FadeImage({ className, src, alt }) {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    if (src === currentSrc) return;

    setOpacity(0);

    // In some cases the transitionend event doesn't fire,
    // so use a timeout instead.
    setTimeout(() => {
      setCurrentSrc(src);
    }, FADE_DURATION);
  }, [src, currentSrc]);

  const handleLoad = () => {
    setOpacity(1);
  };

  return (
    <img
      className={className}
      alt={alt}
      src={currentSrc}
      onLoad={handleLoad}
      style={{ opacity, "--fade-duration": `${FADE_DURATION}ms` }}
    />
  );
}
